// noinspection JSSuspiciousNameCombination

import { utilStyles } from '@Utils/utilStyles';
import type { FC } from 'react';
import React, { useEffect, useRef } from 'react';
import { Animated, Platform, View } from 'react-native';

type Props = {
  isOpen?: boolean;
  width: number;
  height: number;
  color?: string;
  barWidth?: number;
};

export const HamburgerAnimation: FC<Props> = ({
  isOpen = false,
  width,
  height,
  color = 'red',
  barWidth = 2,
}) => {
  const middlePositionTop = height / 2 - barWidth / 2;
  const translateY = height / 2;

  const opacityAnim = useRef(new Animated.Value(0)).current;

  const opacityTo = (x: number) => {
    Animated.timing(opacityAnim, {
      toValue: x,
      duration: 300,
      useNativeDriver: Platform.OS !== 'web',
    }).start();
  };

  useEffect(() => {
    if (isOpen) {
      opacityTo(0);
    } else {
      opacityTo(1);
    }
  }, [isOpen]);

  const barStyleCommon = {
    backgroundColor: color,
    width,
    height: barWidth,
  };

  const dynamicStyleTop = {
    top: middlePositionTop,
    transform: [
      {
        rotate: opacityAnim.interpolate({
          inputRange: [0, 1],
          outputRange: ['45deg', '0deg'],
        }),
      },
      {
        translateY: opacityAnim.interpolate({
          inputRange: [0, 1],
          outputRange: [0, -translateY],
        }),
      },
    ],
  };

  const dynamicStyleMiddle = {
    top: middlePositionTop,
    transform: [
      {
        rotate: opacityAnim.interpolate({
          inputRange: [0, 1],
          outputRange: ['-45deg', '0deg'],
        }),
      },
      {
        translateY: opacityAnim.interpolate({
          inputRange: [0, 1],
          outputRange: [0, translateY],
        }),
      },
    ],
  };

  const dynamicStyleBottom = {
    top: middlePositionTop,
    opacity: opacityAnim,
  };

  return (
    <View
      style={{
        width,
        height,
      }}
    >
      <Animated.View
        style={[utilStyles.absolute, barStyleCommon, dynamicStyleTop]}
      />
      <Animated.View
        style={[utilStyles.absolute, barStyleCommon, dynamicStyleMiddle]}
      />
      <Animated.View
        style={[utilStyles.absolute, barStyleCommon, dynamicStyleBottom]}
      />
    </View>
  );
};
